import { createSlice } from '@reduxjs/toolkit'
import { Slice } from './types'
import { PWAThunk } from 'lib/core/data'
import { AUTH_TOKEN_REFRESH_WINDOW_SECONDS } from 'lib/core/resources/constants'
import { fetchCustomerToken } from 'lib/core/data/customer/token'
import { getIsSuccess, getToken } from 'lib/core/data/customer/token/selectors'
import { setSession } from 'lib/core/data/auth/session'
import { Ga4Events } from '../../../../gtm/index'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false
}

const slice = createSlice({
  name: 'auth/login',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

interface LoginDeps {
  email: string
  password: string
  persistent?: boolean
  onSuccess?: () => void
  onFailure?: () => void
}

export const login = ({
  email,
  password,
  persistent = Boolean(process.env.REACT_APP_PERSISTENT_LOGIN),
  onSuccess,
  onFailure
}: LoginDeps): PWAThunk => {
  return async (dispatch, getState) => {
    dispatch(request())

    await dispatch(fetchCustomerToken({ email, password, persistent }))
    const state = getState()
    const token = getIsSuccess(state) && getToken(state)

    if (token) {
      const tokenExpiration = state.customer.token.payload?.expiration_timestamp
      const scheduleRefresh = tokenExpiration
        ? (parseInt(tokenExpiration) - AUTH_TOKEN_REFRESH_WINDOW_SECONDS) * 1000
        : undefined

      await dispatch(setSession(token, scheduleRefresh))
      Ga4Events.login({ method: 'email' })
      dispatch(success())
      onSuccess?.()
    } else {
      dispatch(failure())
      onFailure?.()
    }
  }
}
